import { supabase } from '../lib/supabase';
import { db } from '../lib/firebase';
import { collection, query, getDocs, where } from 'firebase/firestore';

class DatabaseService {
  // Função auxiliar para determinar qual banco de dados usar
  private getDatabase(source: 'firebase' | 'supabase' = 'supabase') {
    return source === 'firebase' ? db : supabase;
  }

  // Função genérica para buscar dados
  async fetchData(table: string, options: {
    source?: 'firebase' | 'supabase';
    filters?: Record<string, any>;
    orderBy?: string;
    limit?: number;
  } = {}) {
    const { source = 'supabase', filters = {}, orderBy, limit } = options;

    try {
      if (source === 'firebase') {
        let q = query(collection(db, table));
        
        // Aplicar filtros
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            q = query(q, where(key, '==', value));
          }
        });

        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      } else {
        let query = supabase.from(table).select('*');

        // Aplicar filtros
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            query = query.eq(key, value);
          }
        });

        // Aplicar ordenação
        if (orderBy) {
          query = query.order(orderBy);
        }

        // Aplicar limite
        if (limit) {
          query = query.limit(limit);
        }

        const { data, error } = await query;
        if (error) throw error;
        return data;
      }
    } catch (error) {
      console.error(`Erro ao buscar dados da tabela ${table}:`, error);
      throw error;
    }
  }

  // Função específica para buscar métricas
  async fetchMetrics(options: { source?: 'firebase' | 'supabase' } = {}) {
    return this.fetchData('metrics', options);
  }

  // Função específica para buscar estudantes
  async fetchStudents(options: { source?: 'firebase' | 'supabase' } = {}) {
    return this.fetchData('students', options);
  }

  // Função específica para buscar engajamentos de email
  async fetchEmailEngagements(options: { source?: 'firebase' | 'supabase' } = {}) {
    return this.fetchData('email_engagements', options);
  }
}

export const databaseService = new DatabaseService();